import { required } from "../../shared/src/codecs/types/required";
import { uuid } from "../../shared/src/codecs/types/uuid";

export const PartyId = required({
    party_id: uuid(),
});
export type TPartyIdCodec = typeof PartyId;
